import { InferValueTypes } from 'types/commonTypes';

import * as action from './actions';
import * as actionTypes from './actionTypes';
import { UserStore } from './types';

export const initialState: UserStore = {
    id: null,
    user_id: null,
    date_of_birth: null,
    problem_zones: null,
    fitness_level: null,
    gender: null,
    weight: null,
    height: null,
    goal: null,
    goals: null,
    email: null,
    first_name: null,
    last_name: null,
    is_paid: null,
    units: null,
    target_weight: null,
    validation_status: null,
    extra_purchases: null,
    initial_platform: null,
    consent_marketing: null,
    consent_nps: null,
    has_extra_purchases: null,
    nps_group: null,
    payment_platform: null,
    reteno_contact_id: null,
    ab_control: null,
    is_active_plan: null,
    created_at: null,
    initial_setup: null,
    user_has_password_set: null,
    public_id: null,
    first_login_at: null,
    country: null,
    user_error: null,
    features: [],
    abTestPercentage: null,
    w2a_branch: null,
    w2a_test_name: null,
    w2a_gender: null,
    w2a_ab_test_name: null,
};

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const userReducer = (state: UserStore = initialState, action: ActionType): UserStore => {
    switch (action.type) {
        case actionTypes.RESET_USER_DATA:
            return { ...initialState };

        case actionTypes.UPDATE_USER_SUCCESS:

        case actionTypes.GET_CURRENT_USER_SUCCESS:
            return { ...state, ...action.payload };

        case actionTypes.UPDATE_USER_ERROR:
            return { ...state, user_error: action.payload };

        case actionTypes.SET_USER_FEATURES:
            return { ...state, features: action.payload };

        case actionTypes.SET_USER_AB_TEST_PERCENTAGE:
            return { ...state, abTestPercentage: action.payload };

        case actionTypes.GET_USER_PERSONALISATION_SUCCESS:
            return { ...state, ...action.payload };

        case actionTypes.GET_USER_WEB_ANALYTICS_SUCCESS:
            return { ...state, ...action.payload };

        default:
            return state;
    }
};

export default userReducer;
